import { useEffect, useMemo, useState } from "react";
import { ResultsTable } from "./ResultsTable";
import { fetchReport, type DnsReport } from "../lib/reports";

export function ReportPage() {
  const id = useMemo(() => {
    const match = window.location.pathname.match(/^\/report\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }, []);
  const [report, setReport] = useState<DnsReport | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.body.classList.add("report-route");
    document.title = "Shared DNS Report | WhereIsDNS";
    let robots = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = "noindex, nofollow";
    return () => {
      document.body.classList.remove("report-route");
    };
  }, []);

  useEffect(() => {
    if (!id) {
      setError("Report not found.");
      return;
    }
    fetchReport(id)
      .then((next) => setReport(next))
      .catch((e) => setError(String(e instanceof Error ? e.message : e)));
  }, [id]);

  const created = report ? new Date(report.createdAt) : null;

  return (
    <main className="console report-page">
      <section className={`report-hero report-${report?.summary.tone ?? "loading"}`}>
        <span className="landing-eyebrow">Shared DNS report</span>
        <h1>{report ? report.summary.title : "Loading DNS report..."}</h1>
        {report ? (
          <>
            <p className="landing-lede">{report.summary.detail}</p>
            <dl className="report-meta">
              <div><dt>Domain</dt><dd><code>{report.host}</code></dd></div>
              <div><dt>Type</dt><dd>{report.type}</dd></div>
              <div><dt>Captured</dt><dd>{created ? created.toLocaleString() : "unknown"}</dd></div>
              <div><dt>Consensus</dt><dd>{report.summary.agree}/{report.summary.total}</dd></div>
            </dl>
          </>
        ) : null}
        {error ? <p className="error" role="alert">{error}</p> : null}
      </section>

      {report ? (
        <section className="table-panel report-table">
          <div className="panel-title">CAPTURED RESOLVER RESULTS</div>
          <ResultsTable rows={report.rows} topAnswer={report.summary.topAnswer ?? undefined} showHistory={false} />
          <p className="report-note">
            This is an unlisted snapshot of a DNS lookup. DNS may have changed since this report was captured.
          </p>
        </section>
      ) : null}
    </main>
  );
}
